export default "__VITE_ASSET__nYTxfTG2__"